// Single Service (CPT `service`) — guarded so it only runs on single-service.php.
document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('.single-service');
    if (!root) {
        return;
    }

    // Плавный скролл по внутренним якорям контента услуги.
    root.querySelectorAll('a[href^="#"]').forEach(function (link) {
        link.addEventListener('click', function (e) {
            var target = document.querySelector(link.getAttribute('href'));
            if (target) {
                e.preventDefault();
                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        });
    });
});
